import { StateCreator } from 'zustand';

import { AddonsState, CommonStoreType } from '../types';
import { crossSellStags } from '@/helpers/conf';
import { groupMemberSwedish } from '@/helpers/user';
import { generateLoyaltyData } from '@/modules/loyalty/components/helpers';
import { STORAGE, useLocalStorageStore } from '@/store/localStorageStore';

const initialState = {
  ourBenefits: null,
  vip: null,
  aboutUs: null,
  regSlides: undefined,
  regBannerActionBtnRect: null,
  thirdPartySummaries: undefined,
  pendingThirdPartySummaries: false,
  covers: undefined,
  brandAssets: null,
  currentCancelBonusData: undefined,
  loyaltyData: null,
  loyaltyPending: true,
  cmsPaymentMethods: null,
  isVerifyMessage: false,
  isKnowYourLimit: false,
  afterRegStep: false,
  starWinners: null,
  cmsABTests: [],
  registrationBannerData: null,
  livespinsSDK: null,
  mobileAppCMS: null,
  mobileAppCMSPending: false,
  regBanner: null,
};

export const useAddonsSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  AddonsState
> = (_, getState) => {
  return {
    ...initialState,
    getLoyaltyData: () => {
      const { user, compPoints } = getState() || {};

      return !groupMemberSwedish(user)
        ? generateLoyaltyData(compPoints)
        : undefined;
    },

    availableCrossSell: crossSellStags.some(
      (stag) =>
        stag === useLocalStorageStore.getState().get(STORAGE.SPECIAL_STAG)
    ),
  };
};
